import { render, staticRenderFns } from "./PageTemplateDefault.vue?vue&type=template&id=677ab7c2&"
import script from "./PageTemplateDefault.vue?vue&type=script&lang=js&"
export * from "./PageTemplateDefault.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplateDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports